import {
  CustomEventQueryParams,
  CustomEventsResponse as Response,
  convertCustomEvent,
} from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useCustomEvent(params: CustomEventQueryParams, enabled = true) {
  const { server } = useServer()

  return useQuery({
    queryKey: keys.detail(params),
    queryFn: fetchCustomEvent,
    enabled,
    refetchOnMount: 'always',
  })

  async function fetchCustomEvent() {
    const response = await server.get<Response.CustomEvent>(getUrl(params))
    return convertCustomEvent(response)
  }
}

function getUrl(params: CustomEventQueryParams) {
  let url = `/v2/event/custom`

  if ('id' in params) {
    url += '/' + params.id
  } else if ('uri' in params) {
    url = decodeURIComponent(params.uri!)
  }
  return url
}
